import { createFilterOptions } from "@mui/material";
import AutocompleteFormComponent from "components/shared/FormComponent/AutocompleteFormComponent";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import type { CountryCode } from "countries";
import { getCountries } from "countries";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

interface ICountryAutocomplete {
    control: any;
    errors: any;
    required?: boolean;
    onChange?: (data: { name: string; flag: string; code: CountryCode }) => void;
    /** Override the react-hook-form field name. Defaults to "country". */
    controlName?: string;
    /** Override the field label. Defaults to the "NewBeneficiary.Country" i18n key. */
    label?: string;
    disabled?: boolean;
}

const CountryAutocomplete = forwardRef<any, ICountryAutocomplete>(function CountryAutocomplete(
    props: ICountryAutocomplete,
    ref,
) {
    const { control, errors, required = false, onChange, controlName = "country", label: labelProp, disabled } = props;
    const [t] = useTranslation();
    const fieldErrors = (errors as any)[controlName];

    const renderOptionTextCountry = (option: any) => `${option.flag}  ${option.name}`.trim();
    const renderCountryOption = (props: any, option: any) => (
        <li {...props} className="country-list">
            <span>{option.flag}</span>
            <span></span>
            <span>{option.name}</span>
        </li>
    );

    const filterOptionsCountry = createFilterOptions({
        matchFrom: "start",
        stringify: (option: any) => option.name,
    });

    const handleChoosingCountry = (event: React.KeyboardEvent) => {
        if (event.key === "Tab") {
            event.preventDefault();
        }
    };

    const renderInputCountry = (params: any) => (
        <StyledTextField
            {...params}
            error={!!fieldErrors}
            helperText={fieldErrors?.message ?? ""}
            onKeyDown={handleChoosingCountry}
            placeholder={t("AddressPlaceholders.Country")}
        />
    );

    return (
        <AutocompleteFormComponent
            label={labelProp ?? t("NewBeneficiary.Country")}
            options={getCountries().filter((country) => !country.silent)}
            control={control}
            controlName={controlName}
            renderInput={renderInputCountry}
            renderOptionText={renderOptionTextCountry}
            filterOptions={filterOptionsCountry}
            renderOption={(props: any, option: any) => renderCountryOption(props, option)}
            error={fieldErrors}
            required={required}
            onChange={(_e, data) => onChange && onChange(data)}
            disabled={disabled}
            ref={ref}
        />
    );
});

export default CountryAutocomplete;
